import { createGlobalStyle } from 'styled-components'


const GlobalStyle = createGlobalStyle`

  body {
    background-color: #161719;
    ${''/* font-family: 'TTNorms2', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', sans-serif;
    font-size: 16px;
    font-weight: normal;
    font-feature-settings: 'ss02', 'ss01', 'kern', 'liga', 'clig', 'calt';
    text-rendering: optimizeLegibility;
    width: 100%;
    height: 100%;
    margin: 0 !important;
    padding: 0;
    overflow-x: hidden;
    box-sizing: border-box;
    backface-visibility: hidden;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale; */}
  }
`

export default GlobalStyle
